import React, { useContext, useEffect, useState } from "react";
import { Update } from "../App";

const MessageParser = ({ children, actions }) => {
  const { answer, setAnswer } = useContext(Update);
  let valid = false;
  useEffect(() => {
    if (answer.length > 0) {
      actions.handleQuestion();
    }
  }, [answer]);
  const parse = async(message) => {
    const word=message.split(' ')
    if(word.length<2)
    {
      setAnswer("Please input questions in a proper format, separated by spaces.")
    }
    else{
    const options1 = {
      method: "POST",
      headers: {
        accept: "application/json",
        "content-type": "application/json",
        "X-API-KEY": "b829150a-4b10-435d-837b-24d71dfe5313",
      },
      body: JSON.stringify({
        enable_google_results: true,
        enable_memory: true,
        input_text: `does the question ${message} is related to fitness/wrokout?? only write true/false with no description`,
      }),
    };

   await fetch(
      "https://api.writesonic.com/v2/business/content/ans-my-ques?engine=good&num_copies=1",
      options1
    )
      .then((response) => response.json())
      .then((response) => {
        valid = response.message;
        console.log(response)
        if (valid==="True.") {
          const options = {
            method: "POST",
            headers: {
              accept: "application/json",
              "content-type": "application/json",
              "X-API-KEY": "b829150a-4b10-435d-837b-24d71dfe5313",
            },
            body: JSON.stringify({
              enable_google_results: true,
              enable_memory: true,
              input_text: ` No graphical content allowed.${message} try to answer it in 10 words`,
            }),
          };
    
          fetch(
            "https://api.writesonic.com/v2/business/content/chatsonic?engine=good",
            options
          )
            .then((response) => response.json())
            .then((response) => setAnswer(response.message))
            .catch((err) => console.error(err));
        } else {
          
          setAnswer("Question Related to Fitness Only");
        }
      })
      .catch((err) => console.error(err));
    }
    
  };

  return (
    <div>
      {React.Children.map(children, (child) => {
        return React.cloneElement(child, {
          parse: parse,
          actions: {},
        });
      })}
    </div>
  );
};

export default MessageParser;
